declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

export const WHATSAPP_PHONE = '56961391064'
export const WHATSAPP_MESSAGE =
  'Hola quiero solicitar una evaluación estratégica para mi pyme retail con BitzenEscala'

export function getWhatsAppUrl(): string {
  return `https://api.whatsapp.com/send/?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`
}

// Debounce: prevent the same event firing twice in <2s
const recentEvents: Record<string, number> = {}

export type PixelEvent =
  | {
      event: 'CompleteRegistration'
      content_name: string
      content_category: string
    }
  | {
      event: 'AddToCart'
      content_name: string
      content_category: string
      value: number
      currency: string
    }

export function trackPixelEvent(payload: PixelEvent): void {
  if (typeof window === 'undefined') return
  const key = `${payload.event}:${payload.content_name}`
  const now = Date.now()
  const last = recentEvents[key] ?? 0
  if (now - last < 2000) return
  recentEvents[key] = now
  const { event, ...params } = payload
  try {
    window.fbq?.('track', event, params)
  } catch {
    // no-op: pixel not loaded
  }
}

export function scrollToEvaluation(): void {
  const el = document.getElementById('StrategicEvaluation')
  if (!el) return
  const headerOffset = 96 // sticky nav + announcement bar
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset
  window.scrollTo({ top, behavior: 'smooth' })
}
